import { Link } from "react-router-dom";

const points = [
  { icon: "ri-focus-3-line", title: "内容聚合", desc: "把分散的爆料与现场记录整理到一处，减少来回寻找的成本。" },
  { icon: "ri-refresh-line", title: "持续更新", desc: "每日在固定时段持续补充新内容，热门话题优先进入热料榜。" },
  { icon: "ri-book-open-line", title: "完整阅读", desc: "详情页提供完整正文与相关推荐，翻看、阅读、查看一步到位。" },
];

export default function BrandSection() {
  return (
    <section id="about" className="w-full px-4 md:px-8">
      <div className="bg-secondary-900 rounded-lg px-5 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="text-xs md:text-sm text-accent-400 font-medium">关于看料91</span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-white mt-2 leading-snug">
              想看什么直接点，不用绕路
            </h2>
            <p className="text-sm md:text-base text-secondary-100/85 mt-5 leading-relaxed">
              看料91 是一个以"整理与阅读"为核心的内容聚合平台。我们不生产情绪，也不做标题党，而是把同一话题下的现场记录、时间线与相关背景整理清楚，让你点开就能看懂来龙去脉。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/about"
                className="px-5 py-3 bg-accent-500 text-secondary-950 rounded-md text-sm hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                了解更多
              </Link>
              <Link
                to="/contact"
                className="px-5 py-3 border border-secondary-600 text-secondary-50 rounded-md text-sm hover:bg-secondary-800 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                联系我们
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {points.map((p) => (
              <div
                key={p.title}
                className="flex items-start gap-4 bg-secondary-800/70 rounded-lg p-5"
              >
                <span className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                  <i className={`${p.icon} text-2xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-white">{p.title}</h3>
                  <p className="text-sm text-secondary-100/75 mt-1.5 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}